import React from "react";

const CleanInput = (input="") => {
		return input.replace(/&#8217;/g,"'").replace(/&#8218;/g,"'").replace(/&#8220;/g,'"').replace(/&#8221;/g,'"');
	}

export default CleanInput;